
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 89.4 89.4"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M24.86 39.29V74h38.81V39.29z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M28.09 39.3V29.16A15.88 15.88 0 0144 13.31h.49A15.88 15.88 0 0160.3 29.16V39.3"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M55.31 39.3V29.16a10.87 10.87 0 00-10.87-10.87H44a10.87 10.87 0 00-10.92 10.87V39.3M44.5 48.6a13.56 13.56 0 01-6.16 2.08s-2 8.42 6.16 14.47c8.12-6.05 6.15-14.47 6.15-14.47-2.77 0-5.8-1.86-6.15-2.08z"}})])
          )
        }
      }
    